<template>
  <div class="mx-auto max-w-4xl"><p class="eyebrow">Student account</p><h1 class="mt-3 mb-8">Your tuition</h1>
    <div v-if="error" class="error" role="alert">{{ error }} <a href="/" class="underline">Sign in</a></div>
    <div v-else-if="loading" class="card" role="status">Loading your tuition…</div>
    <div v-else class="card"><TuitionSummary v-if="enrollment" :tuition="enrollment" /><p v-else class="leading-relaxed text-slate-600">Your tuition is managed through your existing payment arrangement. Please continue paying as usual. Contact Admissions if you need a balance or have a question.</p></div>
  </div>
</template>
<script>
import { api, errorMessage } from './api';
import TuitionSummary from './TuitionSummary.vue';
export default { components: { TuitionSummary }, data: () => ({ loading: true, enrollment: null, error: '' }),
  async created() { try { const { data } = await api.get('/tuition'); this.enrollment = data.enrollment; } catch (e) { this.error = errorMessage(e); } finally { this.loading = false; } }
};
</script>
